import { Observable } from 'rxjs'
import { MbCartMigrationContext } from '../../../models'
import { Cart } from '@spartacus/cart/base/root'

export abstract class MbCartMigrationAdapter {

  abstract post(userID: string, cartMigrationInfo: MbCartMigrationContext): Observable<Cart>
}
